import "./mainMenu.css";

export type MainMenuProps = {
  isSelected: boolean;
  icon: JSX.Element;
  value: string;
  onClicked: () => void;
};

const MainMenu: React.FC<MainMenuProps> = ({ isSelected, icon, value, onClicked }) => {
  return (
    <div
      className={isSelected ? "main-menu active" : "main-menu"}
      onClick={(e) => {
        onClicked();
      }}
    >
      <div className="overlay"></div>

      {icon}

      <span className="label-medium value">{value}</span>
      {isSelected && <div className="selection-indicator"></div>}
    </div>
  );
};

export default MainMenu;
